import { Reveal } from "./Reveal";
import { Photo } from "./Photo";
import { Quote } from "lucide-react";
import { IMAGES } from "@/constants/images";

export const Philosophy = () => (
  <section id="philosophy" className="relative overflow-hidden border-t border-white/10 py-24 sm:py-32">
    <div
      className="pointer-events-none absolute left-1/3 top-10 h-[50vh] w-[50vh] rounded-full opacity-[0.1] blur-3xl"
      style={{ background: "radial-gradient(circle, #d4af37, transparent 65%)" }}
    />
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-12">
      {/* Portrait */}
      <Reveal className="lg:col-span-5">
        <div className="corner-frame relative mx-auto max-w-sm lg:max-w-none">
          <div className="absolute -inset-3 border border-[#d4af37]/40" />
          <div className="absolute -inset-1.5 border border-[#d4af37]/15" />
          <Photo
            testid="philosophy-portrait"
            src={IMAGES.lifestyle2}
            alt="Shabz Fazl, identity transformation and trading performance coach"
            className="aspect-[4/5] w-full"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0b]/50 via-transparent to-transparent" />
        </div>
      </Reveal>

      {/* Her words */}
      <div className="lg:col-span-7">
        <Reveal>
          <span className="inline-flex items-center gap-3 font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">
            <span className="h-px w-8 bg-[#d4af37]" /> In Her Words
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <Quote className="mt-8 h-10 w-10 text-[#d4af37]/60" strokeWidth={1.2} />
        </Reveal>
        <Reveal delay={0.15}>
          <blockquote
            data-testid="philosophy-quote"
            className="mt-4 font-['Playfair_Display'] text-2xl font-medium leading-snug tracking-tight text-[#f5f5f0] sm:text-3xl lg:text-[2.5rem] lg:leading-[1.2]"
          >
            &ldquo;I help you rebuild your relationship with yourself at an{" "}
            <span className="gold-metallic-text">identity level</span> &mdash; moving from being
            driven by old fear, self-sabotage and conditioned reactions toward operating from a{" "}
            <span className="gold-metallic-text">rebuilt sense of self</span>. So the discipline,
            confidence and consistency you want in life become <em className="not-italic gold-metallic-text">natural</em>,
            rather than something you have to force through willpower.&rdquo;
          </blockquote>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-8 flex items-center gap-4">
            <span className="h-px w-10 bg-[#d4af37]" />
            <cite className="font-['IBM_Plex_Mono'] text-[11px] not-italic uppercase tracking-[0.28em] text-[#a1a1aa]">
              Shabz Fazl &mdash; @shabzfazl
            </cite>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
